import { SPANISH_JOURNEY_PROGRESS_NAMESPACE } from "./spanish-types";

export const LEGACY_SPANISH_PLAN_STORAGE_KEY = `chicky:language_journey_plan:${SPANISH_JOURNEY_PROGRESS_NAMESPACE}`;
export function getSpanishPlanStorageKey(userId: string | null) {
  return `${LEGACY_SPANISH_PLAN_STORAGE_KEY}:identity:${userId ? `user:${encodeURIComponent(userId)}` : "guest"}`;
}
